import React, { Component, useContext } from "react"
import {
    Image,
    Text,
    View,
    StyleSheet,
    ScrollView,
    ActivityIndicator,
    ToastAndroid,
    Platform,
} from "react-native";

import { Formik } from 'formik';
import * as Yup from 'yup';

import { AnalyticsService } from "../../constants/Analytics";

import { AuthContext } from '../../contexts/auth/Store';
import FormikInput from "../../components/form/FormikInput";
import Colors from "../../constants/Colors";
import StyledButton from "../../components/StyledButton";
import FontStyles from "../../constants/FontStyle";
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation } from "@react-navigation/native";
import { CartContext } from "../../contexts/cart/Store";
import { ProductContext } from "../../contexts/product/Store";
import { OrderContext } from "../../contexts/order/Store";
import { HistoryContext } from "../../contexts/history/Store";
import Constants from 'expo-constants';
import * as Device from 'expo-device';
import ConfigService from '../../services/ConfigService';
import ModelBackgroundImage from '../../components/common/ModelBackgroundImage';
import useMounted from "../../hooks/useMounted";
import http from "../../utils/http";
import DeviceTokenService from "../../services/DeviceTokenService";
import { OrderContextActionTypes } from "../../interfaces/order";

const configService = new ConfigService();
const deviceTokenService = new DeviceTokenService()

const LoginSchema = Yup.object().shape({
    phone: Yup.string()
        .matches(/^[0][7-9][0-1][0-9]{8}$/, 'Phone number is invalid')
        .required('Phone number is required')
});

const analytics = new AnalyticsService();

const AuthScreen = function () {
    const navigation = useNavigation()
    const authenticator = useContext(AuthContext)
    const isMounted = useMounted()

    const [cart_state, cart_dispatch, cart_fetch] = React.useContext(CartContext)
    const { product_dispatch, product_fetch } = React.useContext(ProductContext)
    const { state: order_state, dispatch: order_dispatch, action: order_fetch} = React.useContext(OrderContext)
    const [history_state, history_dispatch, history_fetch] = React.useContext(HistoryContext)

    const [isLoading, setLoading] = React.useState(false)
    const [deviceInfo, setDeviceInfo] = React.useState({})

    function _doSignIn(values, actions, authenticator) {
        try {
            let meta = JSON.stringify(deviceInfo)

            let form = new FormData();
            form.append('phone', values.phone)
            form.append('remember', true)
            form.append('version', deviceInfo.app_version_number)
            form.append('platform', Platform.Version)
            form.append('meta', meta)
            http.post('buyer/sesame', form)
                .then(res => {
                    if (res.code === 200 && res.message === true && res.data) {
                        let buyer = res.data
                        form = new FormData()
                        form.append('_id', buyer._id)
                        http.post('buyer/read_details', form, buyer.token)
                            .then(async (detail_res) => {
                                // actions.setSubmitting(false)
                                const authObj = Object.assign({}, buyer, { buyerData: detail_res.data })
                                analytics.mixpanelSetUser(detail_res.data._id, Object.assign({}, detail_res.data, { "$phone": detail_res.data.phone }))

                                analytics.googleHelpers.setUserId(detail_res.data._id)

                                setTimeout(() => {
                                    analytics.logEvent('Logged In', detail_res.data)
                                }, 2500)

                                try {
                                    setLoading(true)
                                    await AsyncStorage.setItem('userToken', authObj.token);
                                    await AsyncStorage.setItem('buyerId', authObj._id);
                                    await AsyncStorage.setItem('buyerData', JSON.stringify(authObj.buyerData));


                                    // get/save grid settings to local storage
                                    await configService.fetchAppConfig()

                                    // get/save FCM token
                                    await deviceTokenService.fetchFcmToken()

                                    // clear any pre-existing data in state
                                    cart_dispatch({ type: 'CLEAR_ALL' })
                                    order_dispatch({ type: OrderContextActionTypes.clear })
                                    product_dispatch({ type: 'CLEAR_ALL' })
                                    history_dispatch({ type: 'CLEAR_ALL' })

                                    Promise
                                        .all([
                                            cart_fetch(),
                                            product_fetch(),
                                            order_fetch(),
                                            history_fetch(),
                                        ])
                                        .then(res => {
                                            isMounted.current && setLoading(false)
                                            isMounted.current && actions.setSubmitting(false)
                                            authenticator.signIn(authObj)
                                        })
                                        .catch(err => {
                                            console.log(err)
                                            isMounted.current && setLoading(false)
                                            isMounted.current && actions.setSubmitting(false)
                                            // ToastAndroid.show(err?.message, ToastAndroid.SHORT, ToastAndroid.BOTTOM)
                                        })
                                } catch (err) {
                                    console.log(err)
                                    isMounted.current && setLoading(false)
                                    isMounted.current && actions.setSubmitting(false)
                                    // ToastAndroid.show(err?.message, ToastAndroid.SHORT, ToastAndroid.BOTTOM)
                                }
                            })
                            .catch((err: any) => {
                                isMounted && actions.setSubmitting(false)

                                // ToastAndroid.show(err?.message || 'An error occured. Try again', ToastAndroid.SHORT, ToastAndroid.BOTTOM)
                            })

                    } else {
                        console.log(res.message)
                        isMounted && actions.setSubmitting(false)
                        // ToastAndroid.show(res.message || 'Account does not exist. Create new account', ToastAndroid.SHORT, ToastAndroid.BOTTOM)
                        navigation.navigate('Onboard', { phone: values.phone })
                    }
                })
                .catch(err => {
                    console.log(err)
                    // ToastAndroid.show(err?.message || 'An error occured. Try again', ToastAndroid.SHORT, ToastAndroid.BOTTOM)
                    isMounted && actions.setSubmitting(false)
                })
        } catch (err) {
            console.log(err)
            // ToastAndroid.show(err?.message || 'An error occured. Try again', ToastAndroid.SHORT, ToastAndroid.BOTTOM)
            isMounted && actions.setSubmitting(false)
        }
    }

    React.useEffect(() => {

        (async () => {
            let platform_spec: any = {
                app_version: Constants.manifest.version,
                app_version_number: Constants.manifest.extra.versionCode,
                device_id: Constants.deviceId,
                device_name: Constants.deviceName,
                device_year_class: Constants.deviceYearClass,
                brand: Device.brand,
                manufacturer: Device.manufacturer,
                model_name: Device.modelName,
                os_name: Device.osName,
                os_version: Device.osVersion,
                os_build_id: Device.osBuildId,
                os_internal_build_id: Device.osInternalBuildId,

                // device_token: await deviceInfoService.fcmToken(),
            }

            if (Platform.OS === 'android') {
                platform_spec = {
                    ...platform_spec,
                    device_product_name: Device.productName,
                    design_name: Device.designName,
                    api_level: Device.platformApiLevel,
                    os_build_fingerprint: Device.osBuildFingerprint,
                }
            }

            isMounted && setDeviceInfo(platform_spec);
        })()

        return () => { }
    }, [])

    return (
        <View style={styles.container}>
            <ScrollView contentContainerStyle={styles.scrollView}>
                <ModelBackgroundImage
                    model={{
                        upload: {
                            path: require('../../assets/images/main/nav-logo.png')
                        }
                    }}
                    style={styles.image}
                    resizeMode="contain"
                    localPath={true}
                />
                {/* <Image source={require('../../assets/images/main/nav-logo.png')} style={styles.image} /> */}
                <Text style={styles.headerText}>Welcome to Suplias</Text>
                {
                    isLoading
                        ? <View>
                            <Text style={styles.subHeaderText}>Buy products at the best prices and enjoy next day delivery. {`\n\n`}</Text>
                            <Text style={styles.loadingHeaderText}>Getting things ready</Text>
                            <View style={{
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginTop: 10,
                            }}>
                                <ActivityIndicator color={Colors.greyColor} size={18} />
                                <Text style={styles.loadingSubHeaderText}>This won't take long.</Text>
                            </View>
                        </View>
                        : <>
                            <Text style={styles.subHeaderText}>Buy products at the best prices and enjoy next day delivery. {`\n\n`}Enter your phone number to continue</Text>
                            <Formik
                                initialValues={{ phone: '' }}
                                onSubmit={
                                    (values, actions) => {
                                        actions.setSubmitting(true)
                                        _doSignIn(values, actions, authenticator)
                                    }
                                }
                                validationSchema={LoginSchema}
                                validateOnMount={false}
                            >
                                {({ handleSubmit, isSubmitting, isValid }) => (
                                    <>
                                        {/* form goes here */}
                                        <FormikInput
                                            label="Your Phone"
                                            icon={{ name: 'md-call' }}
                                            fieldName="phone"
                                            placeholder="Ex. 09060552941"
                                            textContentType='telephoneNumber'
                                            keyboardType='phone-pad'
                                        />

                                        <StyledButton
                                            label="Continue"
                                            disabled={isSubmitting}
                                            submitting={isSubmitting}
                                            style={{
                                                marginTop: 40
                                            }}
                                            action={handleSubmit}
                                        />

                                    </>
                                )}
                            </Formik>
                        </>
                }
            </ScrollView>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'flex-start',
        backgroundColor: Colors.whiteColor,
    },
    scrollView: {
        paddingHorizontal: 25,
        paddingBottom: 40,
        backgroundColor: Colors.whiteColor,
    },
    image: {
        width: 100,
        height: 100,
        // aspectRatio: 96/27.26,
        alignSelf: 'flex-start',
        marginTop: 10
    },
    headerText: {
        alignSelf: 'flex-start',
        color: '#171C34',
        ...FontStyles.size22,
        ...FontStyles.lh26,
        ...FontStyles.bold,
        marginTop: 30,
    },
    subHeaderText: {
        color: '#C4CAD0',
        ...FontStyles.size16,
        ...FontStyles.lh22,
        ...FontStyles.medium,
        alignSelf: 'flex-start',
        marginTop: 6,
        marginBottom: 40
    },
    loadingHeaderText: {
        alignSelf: 'center',
        color: Colors.greyColor,
        ...FontStyles.size18,
        ...FontStyles.lh20,
        ...FontStyles.semibold,
    },
    loadingSubHeaderText: {
        color: Colors.greyColor,
        ...FontStyles.size13,
        ...FontStyles.lh15,
        ...FontStyles.normal,
        marginLeft: 10,
    }
})

export default AuthScreen
